import { createStore } from '@stencil/store';
import { siteType } from '@pes-ui/utils';
import { products, additionalDistributors } from '../../../commerce-connector/__mock__/mocks';
const APP_NAME = 'pesAppTest';
export const getSettings = () => {
  return localStorage.getItem(APP_NAME);
};
const DEFAULT_SETTINGS = {
  appType: 'pesCatalog',
  host: 'https://www.se.com/',
  endpoint: 'product/',
  base_dir: 'catalogBrowse',
  siteType: siteType.B2B,
  showCustomPrice: false,
  showCatalogPrice: true,
  customPrice: {},
  returnBreadcrumbs: (list) => {
    console.log(JSON.stringify(list));
  },
  showBreadcrumbs: true,
  showBuyOnline: false,
  showLinks: true,
  showCompare: false,
  showRecentlyViewed: false,
  showFaq: false,
  language: 'en',
  country: 'us',
  page: '',
  pageId: '',
  usePesRouter: true,
  pesRouterNavigation: 'path',
  showDiscountedPrice: true,
  showDocuments: true,
  dir: 'ltr',
  products,
  additionalDistributors,
  searchParams: '{}',
  ddcAppSource: 'PES_MS_SE',
  hostType: 'Atg',
  useS3: false,
  externalHost: 'https://www.se.com/',
  ddcAllProductsUrl: '',
};
const restoreSettings = () => {
  const settings = getSettings();
  if (!settings) {
    return DEFAULT_SETTINGS;
  }
  return JSON.parse(settings);
};
const getDefaultState = () => {
  return window.location.search.indexOf('use-defaults=true') !== -1
    ? DEFAULT_SETTINGS
    : Object.assign(Object.assign({}, DEFAULT_SETTINGS), restoreSettings());
};
const defaultState = getDefaultState();
export const store = createStore(defaultState);
export const state = store;
export const saveSettings = () => {
  if (typeof window.Proxy === 'function') {
    localStorage.setItem(APP_NAME, JSON.stringify(store.state));
  }
  else {
    const objToSave = {};
    Object.keys(DEFAULT_SETTINGS).forEach((key) => {
      objToSave[key] = store.get(key);
    });
    localStorage.setItem(APP_NAME, JSON.stringify(objToSave));
  }
};
export const updateStorage = (data) => {
  localStorage.setItem(APP_NAME, data);
};
store.on('set', saveSettings);
export var HostTypeValues;
(function (HostTypeValues) {
  HostTypeValues["Atg"] = "Atg";
  HostTypeValues["Spryker"] = "Spryker";
})(HostTypeValues || (HostTypeValues = {}));
